import styled from "styled-components";

const Cost = styled.div`
  font-size: 18px;
  color: #ffffff;
  background-color: #007be5;
  font-weight: 700;
  display: inline-block;
  padding: 0.25em 0.5em;
  margin-bottom: 10px;
  border-radius: 3px;
`;

export default Cost;
